import { render, staticRenderFns } from "./AttemptsList.vue?vue&type=template&id=b280b8ea&"
import script from "./AttemptsList.vue?vue&type=script&lang=js&"
export * from "./AttemptsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports